<canvas #report
        [width]="canvas_width"
        [height]="canvas_height">
</canvas>
